import { observable, action } from 'mobx'

class SupplierModel {
    @observable
    public keyWord: string = ''

    @action
    public setKeyWord(word: string) {
        this.keyWord = word
    }
}

export const supplierModel = new SupplierModel()
